// extracted by mini-css-extract-plugin
module.exports = {"table":"CommercialSizeTable_table__2k8Ad","input":"CommercialSizeTable_input__1NLH4"};